import { render, staticRenderFns } from "./create-invoice.vue?vue&type=template&id=f0fab5ac&"
import script from "./create-invoice.vue?vue&type=script&lang=js&"
export * from "./create-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports